import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { DatabaseProvider } from '../../providers/database/database';
import { AuthProvider } from '../../providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-clinic-medications-add',
  templateUrl: 'clinic-medications-add.html',
})
export class ClinicMedicationsAddPage {

  clinic_name: string;
  clinic_id: string;
  drugtypes: any;
  categories: any;
  medication: any;
  medicationdata: any = {};
  medForm: FormGroup;
  din: FormControl
  name: FormControl;
  type: FormControl;
  category: FormControl;
  sort: FormControl;

  isExisting: boolean = false;
  operation_type: any = 'Add Clinic';

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private viewCtrl: ViewController, 
    public formBuilder: FormBuilder,
    private database: DatabaseProvider,
    private auth: AuthProvider,
    private loadingCtrl: LoadingController) {

    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });

    this.din = new FormControl("", Validators.required);
    this.name = new FormControl("", Validators.required);
    this.type = new FormControl("", Validators.required);
    this.category = new FormControl("", Validators.required);

    this.medication = formBuilder.group({
      din: this.din,
      name: this.name,
      type: this.type,
      category: this.category,
      sort: null
    });

    if (this.navParams.get('meddata')) {
      const med: any = this.navParams.get('meddata');
      this.medication.patchValue(med);
    
      this.isExisting = true;
      this.operation_type = "Edit " + med.name;
    }

    this.drugtypes = [{'name':'Prescription'},{'name': 'Over The Counter'}];
    this.categories = [{'name':'Antibiotics'},{'name': 'Antihistamines'},{'name': 'Anti-Inflammatory'},{'name': 'Steroids'},{'name': 'Other'},{'name': 'No Category'}];
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ClinicMedicationsAddPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addMedication() {
    console.log(this.clinic_id);
    console.log(this.medication.value);
    const med: {} = this.medication.value;
    if(med['sort']) {
      med['sort'] = parseInt(med['sort']);
    }
    else {
      med['sort'] = 1000000;
    }
    med['clinic_only'] = true;
    
    const loader = this.loadingCtrl.create({});
    loader.present()
    this.database.addMedicationByClinic(this.clinic_id, med).then((res) => {
      loader.dismiss();
      console.log('Clinic medication added');
      this.viewCtrl.dismiss();
    })
    .catch((error) => {
      loader.dismiss();
      console.log("Error adding clinic medication");
    })
  }

  updateMedication() {
    console.log(this.clinic_id);
    console.log(this.medication.value);
    const med: {} = this.medication.value;
    if(med['sort']) {
      med['sort'] = parseInt(med['sort']);
    }
    else {
      med['sort'] = 1000000;
    }
    med['clinic_only'] = true;
    
    const loader = this.loadingCtrl.create({});
    loader.present()
    this.database.updateMedicationByClinic(this.clinic_id, med).then((res) => {
      loader.dismiss();
      this.viewCtrl.dismiss();
    })
    .catch((error) => {
      loader.dismiss();
      console.log("error updating medication");
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/clinic-medications-add/clinic-medications-add.ts